import React, { ReactNode } from 'react';
import { useUser } from 'contexts/UserContext';
import { Permission } from 'app-constants';

interface HasPermissionProps {
  groupId: string;
  permission: Permission;
  children: ReactNode;
}

export const HasPermission: React.FC<HasPermissionProps> = ({ groupId, permission, children }) => {
  const { user } = useUser();

  if (!user) {
    return null;
  }

  const orgPermission = user.organizationPermissions.find(
    (perm) => perm.organizationId === groupId
  );


  switch (permission) {
    case Permission.MANAGE_GROUP:
      return orgPermission?.manageGroup ? <>{children}</> : null;
    case Permission.MANAGE_EVENTS:
      return orgPermission?.manageEvents ? <>{children}</> : null;
    case Permission.APPROVE_MEMBER:
      return orgPermission?.approveMember ? <>{children}</> : null;
    default:
      return null;
  }
};

